export default __webpack_public_path__ + "static/media/hms-2.3a790f96.jpeg";